<template>
    <div class="bg-white shadow-md rounded-xl p-4 m-4">
        <MonkeyLoader v-if="isLoading" />
        <h2 class="text-xl font-semibold mb-4 text-gray-800">Entry Invoice SPK Subcon</h2>
        <form @submit.prevent="save">
            <div class="grid grid-cols-1 gap-6">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="invoiceNo">Invoice #</label>
                        <input
                            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 bg-gray-100"
                            id="invoiceNo" type="text" v-model="invoiceNo" placeholder="Nomor Invoice" readonly />
                    </div>
                    <div>
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="invoiceDate">Invoice Date</label>
                        <input class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                            id="invoiceDate" type="date" v-model="invoiceDate" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="invoiceSubconNo">Invoice Subcon
                            #</label>
                        <input class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                            id="invoiceSubconNo" type="text" v-model="invoiceSubconNo"
                            placeholder="Nomor Invoice dari Subcon" />
                    </div>
                    <div>
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="receivedDate">Received
                            Date</label>
                        <input class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                            id="receivedDate" type="date" v-model="receivedDate" />
                    </div>
                </div>

                <div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="subcon">Subcon</label>
                            <select
                                class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                                id="subcon" v-model="subconId">
                                <option value="">-- Pilih Subcon --</option>
                                <option v-for="subcon in uniqueSubcons" :key="subcon.id" :value="subcon.id">
                                    {{ subcon.companyName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                        <div>
                            <label class="block text-gray-700 text-sm font-bold mb-2">Rek. Name</label>
                            <input type="text" :value="selectedSubconInfo?.rekName || ''"
                                class="input-border bg-gray-100 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                                readonly />
                        </div>
                        <div>
                            <label class="block text-gray-700 text-sm font-bold mb-2">Bank</label>
                            <input type="text" :value="selectedSubconInfo?.bankName || ''"
                                class="input-border bg-gray-100 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                                readonly />
                        </div>
                        <div>
                            <label class="block text-gray-700 text-sm font-bold mb-2">Rekening</label>
                            <input type="text" :value="selectedSubconInfo?.rekening || ''"
                                class="input-border bg-gray-100 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                                readonly />
                        </div>
                    </div>
                </div>

                <div>
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="spk">SPK #</label>
                    <div class="flex items-center">
                        <select
                            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="spk" v-model="selectedSpkFileId">
                            <option value="">-- Pilih SPK --</option>
                            <option v-for="spkFile in availableSpkFiles" :key="spkFile.Id" :value="spkFile.Id">
                                {{ spkFile.SpkNum }}
                            </option>
                        </select>
                        <button @click="addSpkToList" type="button"
                            class="ml-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm focus:outline-none focus:shadow-outline whitespace-nowrap">
                            Add to List
                        </button>
                    </div>
                </div>

                <div class="overflow-x-auto mb-4">
                    <table class="min-w-full table-auto">
                        <thead class="bg-gray-200">
                            <tr>
                                <th class="px-4 py-2 border-b text-left">Chk.</th>
                                <th class="px-4 py-2 border-b text-left">No</th>
                                <th class="hidden">SPK Detail ID</th>
                                <th class="hidden">SPK ID</th>
                                <th class="px-4 py-2 border-b text-left">Site Name</th>
                                <th class="px-4 py-2 border-b text-left">Area</th>
                                <th class="px-4 py-2 border-b text-left">Project</th>
                                <th class="px-4 py-2 border-b text-left">Price</th>
                                <th class="px-4 py-2 border-b text-left">Balance Invoice</th>
                                <th class="px-4 py-2 border-b text-left">Start Date</th>
                                <th class="px-4 py-2 border-b text-left">Job Type</th>
                                <th class="px-4 py-2 border-b text-left">SPK #</th>
                                <th class="px-4 py-2 border-b text-left">Inv #</th>
                                <th class="px-4 py-2 border-b text-left">Amount Invoice</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="invoiceDetails.length === 0">
                                <td colspan="14" class="text-center py-4 border-b">No SPK added yet.</td>
                            </tr>
                            <tr v-for="(item, index) in invoiceDetails" :key="item.detailId">
                                <td class="px-4 py-2 border-b"><input type="checkbox" v-model="item.selected"
                                        :disabled="item.balance === 0 || item.isAlreadyInvoiced" /></td>
                                <td class="px-4 py-2 border-b">{{ index + 1 }}</td>
                                <td class="hidden">{{ item.detailId }}</td>
                                <td class="hidden">{{ item.spkFileId }}</td>
                                <td class="px-4 py-2 border-b">{{ item.siteName }}</td>
                                <td class="px-4 py-2 border-b">{{ item.area }}</td>
                                <td class="px-4 py-2 border-b">{{ item.project }}</td>
                                <td class="px-4 py-2 border-b">{{ formatCurrency(item.price) }}</td>
                                <td class="px-4 py-2 border-b">{{ formatCurrency(item.balance) }}</td>
                                <td class="px-4 py-2 border-b">{{ formatDate(item.startDate) }}</td>
                                <td class="px-4 py-2 border-b">{{ item.jobType }}</td>
                                <td class="px-4 py-2 border-b">{{ item.spkNo }}</td>
                                <td class="px-4 py-2 border-b">{{ item.existingInvNum }}</td>
                                <td class="px-4 py-2 border-b">
                                    <input type="number" v-model.number="item.invoiceAmount"
                                        class="w-32 px-2 py-1 text-sm border rounded" :readonly="item.balance === 0" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="flex justify-end mt-4">
                    <span class="text-lg font-semibold text-gray-700">Total:</span>
                    <span class="text-lg font-bold text-gray-900 ml-4">{{ formatCurrency(totalSelectedInvoiceAmount)
                        }}</span>
                </div>
                <div class="mt-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="remarks">Remarks</label>
                    <textarea id="remarks" v-model="remarks" rows="3"
                        class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"></textarea>
                </div>
            </div>

            <div class="flex justify-center mt-6">
                <button
                    class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline mr-2"
                    type="submit">
                    Save
                </button>
                <button
                    class="bg-gray-300 hover:bg-gray-400 text-gray-700 font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
                    type="button" @click="cancel">
                    Cancel
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import MonkeyLoader from '../Layout/MonkeyLoader.vue';

export default {
    name: 'InvoiceEntry',
    components: {
        MonkeyLoader
    },
    data() {
        return {
            invoiceNo: '',
            invoiceDate: new Date().toISOString().slice(0, 10),
            invoiceSubconNo: '',
            receivedDate: new Date().toISOString().slice(0, 10),
            subconId: '',
            selectedSpkFileId: '',
            invoiceDetails: [],
            combinedSubconData: [],
            currentSubconSpks: [],
            remarks: '',
        };
    },
    computed: {
        uniqueSubcons() {
            const seen = new Map();
            this.combinedSubconData.forEach(item => {
                if (!seen.has(item.entityId)) {
                    seen.set(item.entityId, {
                        id: item.entityId,
                        companyName: item.entityName
                    });
                }
            });
            return Array.from(seen.values());
        },
        selectedSubconInfo() {
            if (!this.subconId) return null;
            const data = this.combinedSubconData.find(d => d.entityId === this.subconId);
            if (!data) return null;
            return {
                rekName: data.contactName,
                bankName: data.bankName,
                rekening: data.contactRek,
            };
        },
        availableSpkFiles() {
            if (!this.currentSubconSpks) return [];
            return this.currentSubconSpks.filter(spkFile =>
                spkFile.TblSpksubconDetails && spkFile.TblSpksubconDetails.some(detail => detail.Status === 0)
            );
        },
        totalSelectedInvoiceAmount() {
            return this.invoiceDetails
                .filter(item => item.selected)
                .reduce((total, item) => total + parseFloat(item.invoiceAmount || 0), 0);
        },
    },
    methods: {
        getJobTypeName(jobId) {
            const jobTypes = { 1: 'Survey', 2: 'Install', 3: 'ATP', 4: 'Troubleshoot' };
            return jobTypes[jobId] || 'Unknown';
        },
        async addSpkToList() {
            if (!this.selectedSpkFileId) {
                Swal.fire('Info', 'Silakan pilih SPK terlebih dahulu.', 'info');
                return;
            }
            const spkFileToAdd = this.currentSubconSpks.find(f => f.Id === this.selectedSpkFileId);
            if (!spkFileToAdd || !spkFileToAdd.TblSpksubconDetails) return;

            const existingDetailIds = this.invoiceDetails.map(d => d.detailId);
            const detailsToProcess = spkFileToAdd.TblSpksubconDetails.filter(detail => !existingDetailIds.includes(detail.Id));

            if (detailsToProcess.length === 0) {
                Swal.fire('Info', 'Semua detail dari SPK ini sudah ditambahkan.', 'info');
                return;
            }

            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            const poDataCache = new Map();

            const newDetails = await Promise.all(detailsToProcess.map(async (detail) => {
                let projectName = '', areaName = '', existingInvNum = '';
                const poId = detail.PoId;

                // Ambil info proyek dari PO ID
                if (poId) {
                    if (poDataCache.has(poId)) {
                        ({ projectName, areaName } = poDataCache.get(poId));
                    } else {
                        try {
                            const response = await axios.get(`https://meeting-backend.iotech.my.id/projects-bypo/${poId}`, { headers });
                            if (response.data && response.data.length > 0) {
                                const projectInfo = response.data[0];
                                projectName = projectInfo.name;
                                areaName = projectInfo.city ? projectInfo.city.name : '';
                                poDataCache.set(poId, { projectName, areaName });
                            }
                        } catch (error) { console.error(`Gagal mengambil data untuk PO ID ${poId}:`, error); }
                    }
                }

                // Ambil semua nomor invoice yang sudah ada
                try {
                    const invResponse = await axios.get(`${window.location.origin}/api/invoicesubcon/invnum-by-detail/${detail.Id}`, { headers });
                    if (invResponse.data && invResponse.data.invNums && invResponse.data.invNums.length > 0) {
                        existingInvNum = invResponse.data.invNums.join(', '); // Gabungkan semua nomor invoice
                    }
                } catch (error) {
                    // Error (terutama 404 Not Found) berarti belum ada invoice, biarkan kosong
                }

                // Menggunakan nilai balanceinv yang didapat dari API
                const balance = detail.balanceinv;
                const isAlreadyInvoiced = balance === 0;

                return {
                    selected: !isAlreadyInvoiced, // Pilih secara default jika belum full invoice
                    detailId: detail.Id,
                    spkFileId: spkFileToAdd.Id,
                    siteName: detail.Sitename,
                    area: areaName,
                    project: projectName,
                    price: detail.Price,
                    balance: balance,
                    invoiceAmount: balance, // Default amount invoice adalah saldo
                    startDate: detail.StartDate,
                    jobType: this.getJobTypeName(spkFileToAdd.SpkJob),
                    spkNo: spkFileToAdd.SpkNum,
                    existingInvNum: existingInvNum,
                    isAlreadyInvoiced: isAlreadyInvoiced
                };
            }));

            this.invoiceDetails.push(...newDetails);
            this.selectedSpkFileId = '';
        },
        async generateInvoiceNumber() {
            try {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                const datePart = `${year}${month}${day}`;
                const token = localStorage.getItem('token');
                const response = await axios.get(`${window.location.origin}/api/invoicesubcon/lastnourut`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const lastNoUrut = response.data.lastNoUrut || 0;
                const nextNoUrut = lastNoUrut + 1;
                const sequencePart = String(nextNoUrut).padStart(4, '0');
                this.invoiceNo = `INV-${datePart}-${sequencePart}`;
            } catch (error) {
                console.error('Gagal membuat nomor invoice:', error);
                Swal.fire('Error', 'Gagal membuat nomor invoice otomatis.', 'error');
                this.invoiceNo = 'INV-';
            }
        },
        async fetchData() {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            try {
                const subconCombinedRes = await axios.get(`${window.location.origin}/api/spksubcon/combined-data`, { headers });
                this.combinedSubconData = subconCombinedRes.data;
            } catch (error) {
                console.error('Gagal mengambil data awal:', error);
                Swal.fire('Error', 'Gagal memuat data awal dari server.', 'error');
            }
        },
        async save() {
            const selectedDetails = this.invoiceDetails.filter(d => d.selected);
            if (!this.invoiceNo || !this.subconId || selectedDetails.length === 0) {
                Swal.fire('Warning', 'Harap lengkapi semua field dan pilih minimal satu item SPK yang akan di-invoice.', 'warning');
                return;
            }

            // Validasi Amount Invoice
            for (const detail of selectedDetails) {
                if (detail.invoiceAmount <= 0) {
                    Swal.fire('Warning', 'Jumlah invoice harus lebih dari 0.', 'warning');
                    return;
                }
                if (detail.invoiceAmount > detail.balance) {
                    Swal.fire('Warning', `Jumlah invoice untuk Site ${detail.siteName} (${detail.spkNo}) tidak boleh lebih besar dari sisa saldo (${this.formatCurrency(detail.balance)}).`, 'warning');
                    return;
                }
            }
            const totalInvoice = selectedDetails.reduce((sum, item) => sum + item.invoiceAmount, 0);
            const noUrut = parseInt(this.invoiceNo.split('-')[2], 10) || 0;
            const payload = {
                InvNum: this.invoiceNo,
                InvDate: this.invoiceDate,
                InvSubconNum: this.invoiceSubconNo,
                ReceivedDate: this.receivedDate,
                InvTotal: totalInvoice,
                EntityId: this.subconId,
                NoUrut: noUrut,
                Status: 0,
                Remark: this.remarks,
                invspksubcondetails: selectedDetails.map(d => ({
                    SpkSubconDetailId: d.detailId,
                    Price: d.invoiceAmount,
                    Status: 0
                })),
            };
            try {
                const token = localStorage.getItem('token');
                await axios.post(`${window.location.origin}/api/invoicesubcon`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.fire('Success', 'Invoice berhasil disimpan!', 'success');
                this.resetForm();
            } catch (error) {
                console.error('Gagal menyimpan invoice:', error);
                Swal.fire('Error', `Gagal menyimpan data. ${error.response?.data?.message || ''}`, 'error');
            }
        },
        cancel() {
            this.resetForm();
        },
        resetForm() {
            this.invoiceNo = '';
            this.invoiceDate = new Date().toISOString().slice(0, 10);
            this.invoiceSubconNo = '';
            this.receivedDate = new Date().toISOString().slice(0, 10);
            this.subconId = '';
            this.selectedSpkFileId = '';
            this.invoiceDetails = [];
            this.currentSubconSpks = [];
            this.remarks = '';
            this.generateInvoiceNumber();
        },
        formatCurrency(value) {
            if (value === null || value === undefined) return '';
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(value);
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(dateString).toLocaleDateString('id-ID', options);
        }
    },
    watch: {
        async subconId(newId) {
            this.invoiceDetails = [];
            this.currentSubconSpks = [];
            this.selectedSpkFileId = '';
            if (!newId) return;
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${window.location.origin}/api/subconfilesinv/${newId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                this.currentSubconSpks = response.data;
            } catch (error) {
                console.error(`Gagal mengambil data SPK untuk subcon ${newId}:`, error);
                Swal.fire('Error', 'Gagal memuat data SPK untuk subcon ini.', 'error');
            }
        }
    },
    mounted() {
        this.fetchData();
        this.generateInvoiceNumber();
    },
};
</script>

<style scoped>
.input-border {
    border-bottom: 2px solid #ccc;
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
}

.input-border:focus {
    border-bottom-color: #007bff;
    box-shadow: none;
}
</style>